import React from 'react';
import styles from './styles.module.scss';
import { Facebook, Twitter, GitHub, Instagram, YouTube, LinkedIn } from '@material-ui/icons';
import { Region } from 'utils/i18n/region';
import { FooterLinksInterface } from 'utils/links';
import { useTranslation } from 'react-i18next';

export const Footer: React.FC = (): JSX.Element => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const links: FooterLinksInterface = Region.current.footerLinks;

  const date = new Date();
  return (
    <div className={styles.footerContainer}>
        <div className={styles.widthWrapper}>
            <div className={styles.columnContainer}>
                <div className={styles.linkColumn}>
                    <h5 className={styles.footerHeader}>{t('footer.about_us')}</h5>
                    <a href={`${links.jobs}?lng=${language}`} className={styles.footerLink} target="_blank">
                        <p>{t('footer.jobs')}</p>
                    </a>
                    <a href={`${links.developers}?lng=${language}`} className={styles.footerLink} target="_blank">
                        <p>{t('footer.developers')}</p>
                    </a>
                    <a href={`${links.developerBlog}?lng=${language}`} className={styles.footerLink} target="_blank">
                        <p>{t('footer.developer_blog')}</p>
                    </a>
                    </div>
                    <div className={styles.linkColumn}>
                    <h5 className={styles.footerHeader}>{t('footer.support')}</h5>
                    <a href={`${links.cloverHelp}/${language}/help`} className={styles.footerLink} target="_blank">
                        <p>{t('footer.clover_help')}</p>
                    </a>
                    <a href={`${links.contactUs}?lng=${language}`} className={styles.footerLink} target="_blank">
                        <p>{t('footer.contact_us')}</p>
                    </a>
                    <a href={`${links.deviceSetup}?lng=${language}`} className={styles.footerLink} target="_blank">
                        <p>{t('footer.device_setup')}</p>
                    </a>
                    </div>
                    <div className={styles.linkColumn}>
                    <h5 className={styles.footerHeader}>{t('footer.terms')}</h5>
                    <a href={`${links.terms}?lng=${language}`} className={styles.footerLink} target="_blank">
                        <p>{t('footer.terms')}</p>
                    </a>
                    <a href={`${links.privacyPolicy}?lng=${language}`} className={styles.footerLink} target="_blank">
                        <p>{t('footer.privacy_policy')}</p>
                    </a>
                    <a href={`${links.appMarketTerms}?lng=${language}`} className={styles.footerLink} target="_blank">
                        <p>{t('footer.app_market_terms')}</p>
                    </a>
                    <a href={`${links.appMarketPolicies}?lng=${language}`} className={styles.footerLink} target="_blank">
                        <p>{t('footer.app_market_policies')}</p>
                    </a>
                    <a href={`${links.developerAgreement}?lng=${language}`} className={styles.footerLink} target="_blank">
                        <p>{t('footer.developer_agreement')}</p>
                    </a>
                    <a href={`${links.developerLegalGuidelines}?lng=${language}`} className={styles.footerLink} target="_blank">
                        <p>{t('footer.developer_legal_guidelines')}</p>
                    </a>
                    </div>
                    <div className={styles.linkColumn}>
                    <h5 className={styles.footerHeader}>{t('footer.find_us')}</h5>
                    <a href={links.facebook} className={styles.footerLink} target="_blank">
                        <p>
                        <Facebook className={styles.footerIcon} />
                        {t('footer.facebook')}
                        </p>
                    </a>
                    <a href={links.twitter} className={styles.footerLink} target="_blank">
                        <p>
                        <Twitter className={styles.footerIcon} />
                        {t('footer.twitter')}
                        </p>
                    </a>
                    <a href={links.github} className={styles.footerLink} target="_blank">
                        <p>
                        <GitHub className={styles.footerIcon} />
                        {t('footer.github')}
                        </p>
                    </a>
                    <a href={links.instagram} className={styles.footerLink} target="_blank">
                        <p>
                        <Instagram className={styles.footerIcon} />
                        {t('footer.instagram')}
                        </p>
                    </a>
                    <a href={links.youtube} className={styles.footerLink} target="_blank">
                        <p>
                        <YouTube className={styles.footerIcon} />
                        {t('footer.youtube')}
                        </p>
                    </a>
                    <a href={links.linkedin} className={styles.footerLink} target="_blank">
                        <p>
                        <LinkedIn className={styles.footerIcon} />
                        {t('footer.linkedin')}
                        </p>
                    </a>
                </div>
            </div>
            <div className={styles.copyright}>
                <p>{t('footer.copyright', {date: date.getFullYear()})}</p>
            </div>
        </div>
    </div>
  );
};
